import { SOCIAL_ICON_MAP } from "../../../constants";

export const getProcessedSocialLinks = (socialLinks = {}) => {
    return Object.entries(socialLinks)
        .filter(([key, value]) => key.endsWith("-url") && value)
        .map(([key, value]) => {
            const platform = key.replace("-url", "");
            return {
                platform,
                url: value,
                iconClass: SOCIAL_ICON_MAP[platform] || `ri-${platform}-line`,
            };
        });
};
